// Credentials verrouillées sur le projet Supabase externe
// Les variables Lovable Cloud (.env auto-générée) sont ignorées volontairement

export const SUPABASE_URL = "https://hazvotfzkeryracgfjiy.supabase.co";
export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhhenZvdGZ6a2VyeXJhY2dmaml5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM0MzExNDYsImV4cCI6MjA4OTAwNzE0Nn0._UbqBNjMeu9g6RleyHuDFiZKZyxaY5fDUdkhNztLPj0";
export const SUPABASE_PROJECT_ID = "hazvotfzkeryracgfjiy";
